export const TERM_DELIMITER = "|";

/**
 * Split raw input on the `|` delimiter, trim each fragment, drop blanks, and
 * dedupe case-insensitively (first occurrence wins).
 *
 * @param {string} text
 * @returns {string[]}
 */
export function tokenize(text) {
  const seen = new Set();
  const terms = [];

  for (const fragment of String(text ?? "").split(TERM_DELIMITER)) {
    const term = fragment.trim();
    const key = term.toLowerCase();

    if (!term || seen.has(key)) {
      continue;
    }

    seen.add(key);
    terms.push(term);
  }

  return terms;
}
